<template>
  <v-footer app color="grey-lighten-3" class="text-center py-2">
    <div class="w-100">
      <span class="text-caption text-medium-emphasis">
        © {{ currentYear }} WayWyser. All rights reserved. |
        Powered by <strong>Evolve Tech</strong>
      </span>
    </div>
  </v-footer>
</template>

<script setup>
import { computed } from 'vue';

const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped>
.v-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
